import { Heading, HStack, Tooltip, Text, Box } from "@chakra-ui/react";
import React from "react";
import { IoHelp, IoHelpCircle } from "react-icons/io5";

export default function PageHeading({
  title,
  description,
  icon,
}: {
  title: string;
  description: string;
  icon?: any;
}) {
  return (
    <HStack pr="12px" maxW={{ base: "60vw", md: "40vw" }} overflow="hidden">
      {icon}
      <Heading size="sm" alignItems={"center"} display="flex" noOfLines={1}>
        {title}
      </Heading>
      {description ? (
        <Tooltip label={description} aria-label="Help">
          <Box as="span" display="inline-flex" alignItems="center">
            <IoHelpCircle />
          </Box>
        </Tooltip>
      ) : null}
    </HStack>
  );
}
